export default {
  BOOKING_TIMEOUT_DIALOG_TEXT: {
    title: 'Your window to schedule an appointment has expired',
    subtitle: 'Please reselect a time slot',
    primaryButton: 'Reselect an appointment time'
  }
};
